import React from 'react';
import { Navigate } from 'react-router-dom';
import type { RouteObject } from 'react-router-dom';
import U2000RequireRole from '../u2000Core/components/controls/U2000RequireRole';
import { useU2000AuthContext } from '../u2000Core/context/auth/U2000UseAuthContext';
import U3204, { U3204ROLES } from './U3204';
import U3204ChatScreen from './components/U3204ChatScreen';
import U3204ProductHelpAdminScreen from './components/admin/U3204ProductHelpAdminScreen';

/** Garde ADMIN pour l’écran reindex PRODUCT_HELP (BL-0203). */
const U3204ProductHelpAdminRoute: React.FC = () => {
  const { hasRole } = useU2000AuthContext();
  if (!hasRole(U3204ROLES.ADMIN)) {
    return <Navigate to="/unauthorized" replace />;
  }
  return <U3204ProductHelpAdminScreen />;
};

const U3204Routes: RouteObject[] = [
  {
    path: 'U3204',
    element: <U2000RequireRole allowedRoles={[U3204ROLES.READ]} />,
    children: [
      {
        path: '',
        element: <U3204 />,
        children: [
          { index: true, element: <U3204ChatScreen /> },
          { path: 'admin/product-help', element: <U3204ProductHelpAdminRoute /> },
          { path: ':conversationId', element: <U3204ChatScreen /> },
        ],
      },
    ],
  },
];

export default U3204Routes;
